import HeroSection from "@/sections/HeroSection";
import TrustStripSection from "@/sections/TrustStripSection";
import StatsSection from "@/sections/StatsSection";
import WhoWeAreSection from "@/sections/WhoWeAreSection";
import CoreServicesSection from "@/sections/CoreServicesSection";
import ProductCategoriesSection from "@/sections/ProductCategoriesSection";
import WhyChooseSection from "@/sections/WhyChooseSection";
import ProcessSection from "@/sections/ProcessSection";
import CTASection from "@/components/CTASection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <TrustStripSection />
      <StatsSection />
      <WhoWeAreSection />
      <CoreServicesSection />
      <ProductCategoriesSection />
      <WhyChooseSection />
      <ProcessSection />
      <CTASection titleKey="readyToDiscuss" descKey="ctaDescription" />
    </>
  );
}
